var map = {
	"./Auto.svg": 1013,
	"./af.svg": 9358,
	"./ar-AE.svg": 8572,
	"./ar-EG.svg": 1199,
	"./ar-SA.svg": 4057,
	"./az.svg": 3889,
	"./be.svg": 9791,
	"./bg.svg": 8608,
	"./bn.svg": 850,
	"./bs.svg": 7969,
	"./ca.svg": 1817,
	"./ceb.svg": 9648,
	"./cs.svg": 4334,
	"./cy.svg": 3174,
	"./da.svg": 2154,
	"./de.svg": 6313,
	"./el.svg": 6466,
	"./en-AU.svg": 5155,
	"./en-UK.svg": 3515,
	"./en-US-UK.svg": 149,
	"./en-US.svg": 5926,
	"./eo.svg": 626,
	"./es-ES.svg": 6940,
	"./es-MX.svg": 3125,
	"./es-US.svg": 4397,
	"./et.svg": 7853,
	"./eu.svg": 5915,
	"./fa.svg": 9373,
	"./fi.svg": 6588,
	"./fr-CA.svg": 9436,
	"./fr-FR.svg": 1727,
	"./ga.svg": 2280,
	"./gl.svg": 5749,
	"./gu.svg": 616,
	"./ha.svg": 1973,
	"./hi.svg": 8175,
	"./hmn.svg": 7449,
	"./hr.svg": 4854,
	"./ht.svg": 1037,
	"./hu.svg": 2542,
	"./hy.svg": 2679,
	"./id.svg": 4517,
	"./ig.svg": 3646,
	"./is.svg": 8206,
	"./it.svg": 9126,
	"./iw.svg": 6336,
	"./ja.svg": 8964,
	"./jw.svg": 5207,
	"./ka.svg": 4256,
	"./kk.svg": 4959,
	"./km.svg": 8825,
	"./kn.svg": 6788,
	"./ko.svg": 7006,
	"./la.svg": 3152,
	"./lo.svg": 7302,
	"./lt.svg": 43,
	"./lv.svg": 3202,
	"./mg.svg": 3355,
	"./mi.svg": 3491,
	"./mk.svg": 6885,
	"./ml.svg": 6666,
	"./mn.svg": 3142,
	"./mr.svg": 1182,
	"./ms.svg": 516,
	"./mt.svg": 7210,
	"./my.svg": 9326,
	"./ne.svg": 1420,
	"./nl.svg": 3459,
	"./no.svg": 9749,
	"./ny.svg": 8532,
	"./pa.svg": 3653,
	"./pl.svg": 6206,
	"./pt-BR.svg": 1419,
	"./pt-PT.svg": 5870,
	"./ro.svg": 9473,
	"./ru.svg": 3201,
	"./si.svg": 4945,
	"./sk.svg": 1306,
	"./sl.svg": 5274,
	"./so.svg": 9411,
	"./sq.svg": 6293,
	"./sr.svg": 2859,
	"./st.svg": 860,
	"./su.svg": 9065,
	"./sv.svg": 3395,
	"./sw.svg": 2116,
	"./ta.svg": 4788,
	"./te.svg": 2099,
	"./tg.svg": 5440,
	"./th.svg": 8062,
	"./tl.svg": 4784,
	"./tr.svg": 4921,
	"./uk.svg": 8273,
	"./ur.svg": 7119,
	"./uz.svg": 5675,
	"./vi.svg": 5619,
	"./yi.svg": 9596,
	"./yo.svg": 4311,
	"./zh-CN.svg": 6550,
	"./zh-HK.svg": 1356,
	"./zh-TW.svg": 8873,
	"./zu.svg": 8972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5960;